// @ts-nocheck
import React, { HTMLAttributes } from 'react';
import NoImage, { NotFoundImage } from "../NoImage";
import { observer } from "mobx-react";
import { observable } from "mobx";

export type ImageType = "base64" | "src" | "promise"

type Props = {
  type?: ImageType,
  src?: any,
  alt?: string,
  noFoundImage?: NotFoundImage
}

@observer
class Img extends React.Component<Props & HTMLAttributes<HTMLImageElement>> {

  @observable imageSrc: string;

  render() {
    const {type} = this.props;
    return this.imageSrc
      ? <img {...this.props}
             src={type && type === "base64" ? ("data:image/png;base64, " + this.imageSrc) : this.imageSrc}/>
      : <NoImage className={this.props.className} image={this.props.noFoundImage}/>;
  }

  componentDidUpdate(prevProps: Readonly<Props & React.HTMLAttributes<HTMLImageElement>>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.src !== this.props.src) {
      this.init();
    }
  }


  componentDidMount(): void {
    this.init();
  }

  init() {
    if (this.props.type === 'promise' && this.props.src) {
      this.props.src.then((response: string) => {
        this.imageSrc = response
      }).catch(() => {
      })
    } else {
      this.imageSrc = this.props.src
    }
  }
}

export default Img;
